import { validateLayer } from "../model/surfDeck.js";
import { getSurfLayout } from "./templates.js";
export function validateDesignerOutput(raw) {
    const layout = getSurfLayout(raw.layoutId);
    if (!layout)
        return `Layout sconosciuto: ${raw.layoutId}`;
    if (!Array.isArray(raw.layers) || !raw.layers.length)
        return "Nessun layer nel output designer.";
    const slotRoles = new Set(layout.slots.map((s) => s.role));
    for (const layer of raw.layers) {
        if (!slotRoles.has(layer.slotRole)) {
            return `Slot non valido per layout ${raw.layoutId}: ${layer.slotRole}`;
        }
        if (!String(layer.content ?? "").trim()) {
            return `Contenuto vuoto per slot ${layer.slotRole}`;
        }
    }
    return null;
}
export function validateLayersForLayout(layers, layout) {
    for (const layer of layers) {
        const err = validateLayer(layer);
        if (err)
            return err;
    }
    if (!layout)
        return null;
    for (const slot of layout.slots) {
        const match = layers.find((l) => l.style?.slotRole === slot.role || l.textRole === slot.textRole);
        if (!match && slot.role !== "image") {
            /* optional slots ok */
        }
    }
    return null;
}
/** Reject layers with normalized coords out of range (server-side style check). */
export function assertValidDesignerLayers(layers) {
    const err = validateLayersForLayout(layers);
    if (err)
        throw new Error(`Layout designer non valido: ${err}`);
}
